module.exports = __webpack_public_path__ + "static/media/icon_indicaciones_para_estudios.da534fa0.svg";